import { Injectable } from '@angular/core';
import { AuthInterceptor } from './auth.interceptor';
import { AuthExpiredInterceptor } from './auth-expired.interceptor';
import { ErrorHandlerInterceptor } from './errorhandler.interceptor';
import { NotificationInterceptor } from './notification.interceptor';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { EventManager } from 'ng-jhipster';
import { Router } from '@angular/router';
import { Injector } from '@angular/core';
import { MaintenanceInterceptor } from './maintenance.interceptor';

@Injectable()
export class InterceptorFactory {
  constructor( private localStorage: LocalStorageService,
               private sessionStorage: SessionStorageService,
               private injector: Injector,
               private router: Router,
               private eventManager: EventManager) {}

  createAuthInterceptor() {
    return new AuthInterceptor(this.localStorage, this.sessionStorage);
  }

  createAuthExpiredInterceptor() {
    return new AuthExpiredInterceptor(this.injector);
  }

  createErrorHandlerInterceptor() {
    return new ErrorHandlerInterceptor(this.eventManager);
  }

  createNotificationInterceptor() {
    return new NotificationInterceptor();
  }

  createMaintenanceInterceptor() {
    return new MaintenanceInterceptor(this.router);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/http/interceptor/interceptor-factory.ts